import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import Parse, { domToReact } from 'html-react-parser';

import Basepage, { BasePageState } from '../Basepage';
import FilterRow, { FilerTranslateItem } from './parts/FilterRow';

import FilterResult from './parts/FilterRow/FilterResult';
import ResultItemContainer from './parts/ResultItemContainer';

import './index.scss';
import { replaceAllComplex } from '../../../../mol_function';
import ProductCarousel from '../Basepage/parts/ProductCarousel';
import {
  browserUrlToReactUrl,
  reactUrlToBrowserUrl,
} from '../../../../urlParse';
import MolLink from '../Basepage/parts/Menu/MolLink';

import Loading from '../Basepage/parts/Loading';
import ProdurctSearchResult from './parts/ProdurctSearchResult';

interface SearchPageState extends BasePageState {
  Products: ProdurctSearchResult[];
  loading: boolean;
  pageID: number;
  endOfSearch: boolean;
  partial: boolean;
  //PageUrl: string;
}

interface SearchPageModel {
  numFound: number;
  error: boolean;
  partialResults?: boolean;
  filterTranslate: FilerTranslateItem[];
  filter: any;
  top_banner: string;
  top_banner_link: string;
  top_banner_caption: string;
  bannerbox_1: string;
  bannerbox_1_link: string;
  bannerbox_1_caption: string;
  bannerbox_2: string;
  bannerbox_2_link: string;
  bannerbox_2_caption: string;
  featured_products: ProductCarouselModel[];
  Products: ProdurctSearchResult[];
  html?: string;
  skipFacet: boolean;
}

export default class SearchPage extends Basepage<
  SearchPageState,
  SearchPageModel
> {
  pageTitleGetter(): string {
    return '';
  }
  pageHeaderGetter(): string {
    return '';
  }

  getType(): string {
    return 'SearchPage';
  }
  getBreadCrumb(): JSX.Element {
    return (
      <React.Fragment>
        <span>Ihre Suchergebnis</span>
      </React.Fragment>
    );
  }

  initJSChild(): string {
    return '';
  }
  endRef: any;
  FilterRowRef: any;

  constructor(props: any) {
    super(props);
    this.endRef = React.createRef();
    this.FilterRowRef = React.createRef();
  }

  getApiReqestUrl(): string {
    let dummyProps: any = this.props;
    let location: any = dummyProps.location;
    let query = '';
    //TODO Check empty search;
    query = location.search.substring(1);

    if (!query.includes('keyword=')) {
      if (query.length == 0) {
        query = 'keyword=';
      } else {
        query += '&keyword=';
      }
    }

    return (
      this.state.apiBase +
      '/index.php?frame=api&main_page=advanced_search_result&' +
      query
    );
  }

  getRightBreadCrumbParts(): JSX.Element {
    return null;
  }

  initState(base: BasePageState): SearchPageState {
    let dummy: any = this.props;

    let products: ProdurctSearchResult[] = [];
    let partialResult = true;

    if (base.hasApiData) {
      products = this.body.Products;
      partialResult = this.body.partialResults == true;
    }

    let newState: SearchPageState = {
      ...base,
      Products: products,
      loading: false,
      pageID: 0,
      endOfSearch: false,
      partial: partialResult,
    };

    return newState;
  }

  childDidMount(): void {
    window.onscroll = this.windowsScrollHandle;
    //this.setState({ Products: this.body.Products, loading: false });
    this.windowsScrollHandleAsync();
  }
  childDidUnmount(): void {
    let anyProps: any = this.props;
    anyProps.location.search;
    let scrollbackInfo = {
      path: anyProps.location.search,
      scrollPosition: window.scrollY,
    };
    let mywindow: any = window;

    mywindow.scrollbackInfo = scrollbackInfo;

    window.onscroll = null;
  }

  childDidUpdate(prevProp: any, prevState: any) {
    if (this.state.apiData) {
      if (!prevState.apiData) {
        //COPY First data package
        let productArray = this.body.Products;
        this.setState({ Products: productArray });
        //check scroll in Timer (Wait for setState)
        setTimeout(() => {
          this.windowsScrollHandleAsync();
        }, 100);
      }
    } else {
      if (this.state.Products != undefined && this.state.Products.length > 0)
        //Clear StateProducts
        this.setState({ Products: [] });
    }
  }

  renderChild(): JSX.Element {
    let stateInfo = {};

    if (this.state.hasApiData) {
      stateInfo = this.state.apiData;
    }
    //TODO Load JQuery
    //TODO FIX keyword
    //let keyword = this.state?.queryParams["keyword"] ?? "*";

    let queryParams = this.state.queryParams;

    delete queryParams['searchBoost'];

    let keyword = queryParams.keyword;

    let topBanner = null;
    let banner1 = null;
    let banner2 = null;
    let apdItems = null;

    let topHtml = null;
    if (this.body.top_banner != undefined && this.body.top_banner != '') {
      let topBannerItem = (
        <img
          src={this.state.renderingDomain + this.body.top_banner}
          alt={this.body.top_banner_caption}
        ></img>
      );
      if (
        this.body.top_banner_link != undefined &&
        this.body.top_banner_link != ''
      ) {
        let domainPrefix = this.state.renderingDomain;
        if (this.body.top_banner_link.startsWith('http')) {
          domainPrefix = '';
        }

        if (
          !this.body.top_banner_link.startsWith('http') &&
          !domainPrefix.endsWith('/') &&
          !this.body.top_banner_link.startsWith('/')
        )
          domainPrefix += '/';

        topBannerItem = (
          <a href={domainPrefix + this.body.top_banner_link}>{topBannerItem}</a>
        );
      }
      topBanner = <div id="search_top_banner">{topBannerItem}</div>;
    }

    if (this.body.bannerbox_1 != undefined && this.body.bannerbox_1 != '') {
      let banner1Item = (
        <img
          src={this.state.renderingDomain + this.body.bannerbox_1}
          alt={this.body.bannerbox_1_caption}
        ></img>
      );
      if (
        this.body.bannerbox_1_link != undefined &&
        this.body.bannerbox_1_link != ''
      ) {
        let domainPrefix = this.state.renderingDomain;
        if (this.body.bannerbox_1_link.startsWith('http')) {
          domainPrefix = '';
        }

        if (
          !this.body.bannerbox_1_link.startsWith('http') &&
          !domainPrefix.endsWith('/') &&
          !this.body.bannerbox_1_link.startsWith('/')
        )
          domainPrefix += '/';

        banner1Item = (
          <a href={domainPrefix + this.body.bannerbox_1_link}>{banner1Item}</a>
        );
      }
      banner1 = <div id="search_bannerbox_1">{banner1Item}</div>;
    }

    if (this.body.bannerbox_2 != undefined && this.body.bannerbox_2 != '') {
      let banner2Item = (
        <img
          src={this.state.renderingDomain + this.body.bannerbox_2}
          alt={this.body.bannerbox_2_caption}
        ></img>
      );
      if (
        this.body.bannerbox_2_link != undefined &&
        this.body.bannerbox_2_link != ''
      ) {
        let domainPrefix = this.state.renderingDomain;
        if (this.body.bannerbox_2_link.startsWith('http')) {
          domainPrefix = '';
        }

        if (
          !this.body.bannerbox_2_link.startsWith('http') &&
          !domainPrefix.endsWith('/') &&
          !this.body.bannerbox_2_link.startsWith('/')
        )
          domainPrefix += '/';

        banner2Item = (
          <a href={domainPrefix + this.body.bannerbox_2_link}>{banner2Item}</a>
        );
      }
      banner2 = <div id="search_bannerbox_2">{banner2Item}</div>;
    }

    if (this.body.html != undefined) {
      let htmlParserOptions = {
        replace: (domNode: any) => {
          if (domNode.type == 'tag' && domNode.name == 'a') {
            let reactUrl = browserUrlToReactUrl(domNode.attribs.href, null);
            if (reactUrl != '') {
              let molHref = reactUrlToBrowserUrl(reactUrl, null, null);
              if (molHref != '') {
                return (
                  <MolLink
                    href={this.state.renderingDomain + molHref}
                    to={reactUrl}
                    title={domNode.attribs.title}
                    children={domToReact(domNode.children, htmlParserOptions)}
                    inlinePadding={true}
                    orgHref={domNode.attribs.href}
                  />
                );
              }
            }
          } else if (
            domNode.type == 'tag' &&
            domNode.name == 'div' &&
            domNode.attribs['data-flickity-options'] != undefined
          ) {
            /*
            return (
              <Carousel
                height="250px"
                itemWidth="200"
                showMultiple={true}
                showDots={true}
                disableDrag={false}
                clickHandle={(
                  dragChild: any,
                  children: [],
                  index: number,
                  event: any,
                ) => {
                  if (event.type == 'touchend') {
                    let link = dragChild;
                    if (dragChild.tagName == 'IMG') {
                      link = dragChild.parentElement;
                    }
                    link.click();
                  }
                }}
                children={domToReact(domNode.children, htmlParserOptions)}
              />
            );
            */
            //TODO: Transform flicky
          }
        },
        trim: true,
      };

      let cleanHtml = this.body.html;

      if (DOMPurify != undefined && DOMPurify.sanitize != undefined) {
        const sanitizer = DOMPurify.sanitize;
        cleanHtml = sanitizer(this.body.html);
      }

      topHtml = (
        <div id="search_html">{Parse(cleanHtml, htmlParserOptions)}</div>
      );
    }

    if (
      this.body.featured_products != undefined &&
      this.body.featured_products.length > 0
    ) {
      apdItems = (
        <ProductCarousel items={this.body.featured_products}></ProductCarousel>
      );
    }
    //featured_products

    let items = this.state.Products;

    if (items == null || items == undefined) {
      items = [];
    }

    let queryString = '';

    let keys = Object.keys(queryParams);
    for (let i = 0; i < keys.length; i++) {
      queryString += keys[i] + '=' + queryParams[keys[i]];
      if (i + 1 < keys.length) {
        queryString += '&';
      }
    }

    let queryString2 = '';
    if (queryString.length > 0) queryString2 = queryString + '&searchBoost';
    else queryString2 = 'searchBoost';

    let boosterLink = '/search_page/?' + queryString2;
    let boosterBrowserLink = reactUrlToBrowserUrl(
      '/search_page/',
      queryString,
      null,
    );

    return (
      <div id="searchPage">
        <FilterRow
          filterData={this.body.filter}
          filterTranslate={this.body.filterTranslate}
          queryParams={queryParams}
          pageMode={this.state.mode}
          totalItems={this.body.numFound}
          apiBase={this.state.apiBase}
          ref={this.FilterRowRef}
        ></FilterRow>

        <div id="searchHeader">
          {topBanner}
          {banner1}
          {banner2}
          {apdItems}
          {topHtml}
        </div>

        {keyword != undefined &&
        keyword != null &&
        keyword != '*' &&
        keyword.trim() != '' ? (
          <h1 id="advSearchResultsDefaultHeading">
            <span className="suchtitel">Ihre Suche nach: </span>
            <span className="suchwort">
              {replaceAllComplex(keyword, [
                { s: '+', r: ' ' },
                { s: '%2C', r: ',' },
                { s: '%3F', r: '?' },
                { s: '%26', r: '&' },
              ])}
            </span>
          </h1>
        ) : null}

        <form
          className="facet_form"
          action="index.php?main_page=advanced_search_result&amp;search_in_description=1"
          method="GET"
          id="remove-search-form"
        >
          <input
            type="hidden"
            name="main_page"
            value="advanced_search_result"
          />
          <input type="hidden" name="keyword" value={keyword} />
          <input type="hidden" name="hideeol" id="hideeol" value="0" />
        </form>

        {this.body.error ? (
          <div>
            <MolLink to={boosterLink} href={boosterBrowserLink}>
              Ups, Sorry, da ist etwas schief gelaufen, Sie können Ihre Suche
              hier wiederholen!
            </MolLink>
          </div>
        ) : null}
        <FilterResult
          filterTranslate={this.body.filterTranslate}
          queryParams={queryParams}
          filterData={this.body.filter}
          totalItems={this.body.numFound}
          showTopBorder={topHtml != null || topBanner != null}
          searchHasError={this.body.error}
          partialResult={this.state.partial}
        ></FilterResult>
        <ResultItemContainer
          items={items}
          domainPrefix={this.state.renderingDomain}
          itemsCount={this.body.numFound}
        />
        {this.state.loading ? (
          <div style={{ textAlign: 'center' }}>
            <Loading />
          </div>
        ) : null}
        <div id="endDiv" ref={this.endRef}></div>
      </div>
    );
  }

  windowsScrollHandle(e: any) {
    if (
      window.currentPage != undefined &&
      window.currentPage.windowsScrollHandleIntern != undefined &&
      window.currentPage.windowsScrollHandleIntern instanceof Function
    )
      window.currentPage.windowsScrollHandleIntern();
  }

  windowsScrollHandleAsync() {
    if (this.endRef.current != undefined) {
      this.windowsScrollHandleIntern();
    } else {
      setTimeout(() => {
        this.windowsScrollHandleAsync();
      }, 100);
    }
  }

  windowsScrollHandleIntern() {
    if (this.endRef.current != undefined) {
      let endPosition = this.endRef.current.offsetTop;
      let windowPosition = window.scrollY + window.innerHeight;
      let scrollStart = 1000;

      let scrollback = false;

      let mywindow: any = window;

      let scrollbackInfo = mywindow.scrollbackInfo;
      if (scrollbackInfo != null) {
        let anyProps: any = this.props;
        let currentSearch = anyProps.location.search;
        if (currentSearch == scrollbackInfo.path) {
          scrollback = window.scrollY < scrollbackInfo.scrollPosition;
          if (scrollback) {
            let scrollPosition =
              this.endRef.current.offsetTop - window.innerHeight / 2;

            if (this.endRef.current.offsetTop > scrollbackInfo.scrollPosition) {
              scrollPosition = scrollbackInfo.scrollPosition;
            }
            window.scrollTo(0, scrollPosition);
          } else {
            mywindow.scrollbackInfo = null;
          }
        } else {
          mywindow.scrollbackInfo = null;
        }
      }

      if (this.state?.Products != undefined) {
        if (
          windowPosition + scrollStart > endPosition ||
          this.body.skipFacet ||
          scrollback
        ) {
          if (
            (this.body.numFound > this.state.Products.length &&
              !this.state.endOfSearch) ||
            (this.body.numFound > 0 && this.body.skipFacet)
          ) {
            if (!this.state.loading) {
              this.fetchNextPage();
            }
          }
        }
      }
    }
  }

  fetchNextPage() {
    let queryParams = this.state.queryParams;

    let pageId = 1;

    if (this.state.pageID != undefined && this.state.pageID > 0) {
      pageId = this.state.pageID;
    }

    let nextPageID = pageId + 1;

    this.setState({ loading: true });

    queryParams['page'] = pageId;

    let newQueryString = '';
    let keys = Object.keys(queryParams);
    for (let i = 0; i < keys.length; i++) {
      let value = queryParams[keys[i]];
      newQueryString += '&' + keys[i] + '=' + value;
    }

    let requestUrl =
      this.state.apiBase +
      '/index.php?main_page=advanced_search_result&frame=api' +
      newQueryString;

    fetch(requestUrl, {
      headers: {
        SearchControlSkipFacet: this.body.skipFacet ? 'false' : 'true',
        'Content-Type': 'application/json',
        // 'User-Agent': 'React-Shop-Search-Dynamic-Load',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.body.error) {
          let oldProducts = this.state.Products;
          let newProducts = data.body.Products;

          for (let i = 0; i < newProducts.length; i++) {
            oldProducts.push(newProducts[i]);
          }
          let newstate = {
            Products: oldProducts,
            loading: false,
            endOfSearch: data.body.endOfSearch,
            pageID: nextPageID,
          };

          if (!data.body.skipFacet && this.body.skipFacet) {
            this.body.skipFacet = data.body.skipFacet;
            this.FilterRowRef.current.setState({
              filterData: data.body.filter,
              filterTranslate: data.body.filterTranslate,
            });
          }

          this.setState(newstate);

          this.windowsScrollHandleIntern();
        } else {
          this.body.error = true;
          this.setState({
            loading: false,
            endOfSearch: true,
          });
        }
      });
  }
}
